import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import Inputs from "../../components/inputs/Inputs";
import Input from "../../components/inputs/_Input";
import Button from "../../components/button/Button";
import WelcomeCard from "../../components/login/WelcomeCard";
import { ReactComponent as LoginEye } from "../../assets/icons/login/login-close-eye.svg";
// import { ReactComponent as SendCode } from "../../assets/icons/login/SendCode.svg";
// import { ReactComponent as  } from "../../assets/icons/login/Close.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/login/login-cross.svg";
import "./PassRecover.css";
import { useNavigate } from "react-router-dom";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import axios from "axios";
import imgParallax from "../../assets/icons/login/3d-rendering-triangle-water.png";
import ParallaxImage from "../../components/ParallaxImage/ParallaxImage";
import { useTranslation } from "react-i18next";

const PassRecover = () => {
  const {t} = useTranslation()
  const token = localStorage.getItem("token");

  const navigate = useNavigate();
  const [inputData, setInputData] = useState({
    email: "",
    codeMail: "",
    newPass: "",
    newPass2: "",
  });
  const [emailError, setEmailError] = useState("e-mail cannot be empty!");
  const [emailDirty, setEmailDirty] = useState(false);
  const [formValid, setFormValid] = useState(false);

  const action = (snackbarId) => (
    <CloseIcon
      onClick={() => {
        closeSnackbar(snackbarId);
      }}
    />
  );

  const handleSubmit = (event) => {
  // event.preventDefault(); // Если кнопка внутри form, это обязательно нужно раскомментировать!
  
  const email = inputData.email.trim(); // Убираем случайные пробелы по краям

  if (!/^\S+@\S+\.\S+$/.test(email)) {
    enqueueSnackbar(t("recovery.incorrectFormatEmail"), {
      action,
      autoHideDuration: 3000,
      variant: "error",
      className: "snackerror",
    });
    return; // Обязательно выходим из функции
  }

  // 1. Кодируем email для URL
  const encodedEmail = encodeURIComponent(email);

  axios
    .post(
      `https://api-ru.fynex.cc/api/api/users/password/reset?email=${encodedEmail}`
    )
    .then((res) => {
      // setInputData({ ...inputData, email: "" });
      enqueueSnackbar(t("recovery.newPass"), {
        action,
        autoHideDuration: 3000,
        variant: "success",
        className: "snacksuccess",
      });
    })
    .catch((error) => {
      // 2. Безопасное получение текста ошибки
      let errMsg = "Unknown error";
      const detail = error.response?.data?.detail;

      if (Array.isArray(detail) && detail[0]?.msg) {
        // Формат массива ошибок (FastAPI validation)
        errMsg = detail[0].msg;
      } else if (typeof detail === "string") {
        // Обычная текстовая ошибка
        errMsg = detail;
      } else if (error.message) {
        // Ошибка сети или JS
        errMsg = error.message;
      }

      // Перевод специфичной ошибки, если нужно
      if (errMsg === "Email error" || errMsg.includes("not found")) {
         errMsg = "Неверный email"; 
      }

      enqueueSnackbar(`${t("recovery.error")} ${errMsg}`, {
        action,
        autoHideDuration: 3000,
        variant: "error",
        className: "snackerror",
      });
    });
};

  const changePass = () => {
    axios
      .post(
        `https://api-ru.fynex.cc/api/api/users/password/change`,
        { password: inputData.newPass, repeatPassword: inputData.newPass2 },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        enqueueSnackbar(`${t("recovery.changePass")}`, {
          action,
          variant: "success",
          className: "snacksuccess",
        });
        // setHdnpp(true)
        console.log(res);
      })
      .catch(function (error) {
        error.response.data.detail.map((errormsg) => {
          enqueueSnackbar(`${t("recovery.error")} ${errormsg.msg}`, {
            action,
            variant: "error",
            className: "snackerror",
          });
        });
      });
  };

  return (
    <div className="container">
      <div className="container-left-image">
        <ParallaxImage
          containerClassName="container"
          imageClassName="left-image"
          src={imgParallax}
          alt="Parallax"
        />
      </div>
      <div className="PassRecover">
        {/* <Header /> */}
        <div className="recover-wrapper">
          <div className="recover">
            <WelcomeCard text={t("recovery.welcomeCard")} />

            <Inputs>
              <Input
                placeholder={t("recovery.emailOrTel")}
                // icon={<SendCode />}
                btn={true}
                onChange={(e) =>
                  setInputData({ ...inputData, email: e.target.value })
                }
              />
            </Inputs>

            <div className="action">
              <Button
                text={t("recovery.restorePass")}
                onClick={() => handleSubmit()}
              />
              <p>
                {/* Вспомнили пароль?{" "} */}
                {t("recovery.rememberedPass")}
                <span onClick={() => navigate("/Login")}> {t("recovery.login")}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PassRecover;
